import ContractsCargoTaxiDetailsRequest from "../../../../api/raily/contracts/cargo-taxi/details/contracts-cargo-taxi-details.request";
import ContractsCargoTaxiDetailsParams from "./contracts-cargo-taxi-details-params";

const create = (
  params: ContractsCargoTaxiDetailsParams,
): ContractsCargoTaxiDetailsRequest => {
  return {
    contractId: params.contractUuid,
  };
};

const contractsCargoTaxiDetailsParamsFactory = {
  create,
};

export default contractsCargoTaxiDetailsParamsFactory;
